import { render } from "./TasksCharts.vue?vue&type=template&id=3deb3de0"
import script from "./TasksCharts.vue?vue&type=script&lang=js"
export * from "./TasksCharts.vue?vue&type=script&lang=js"
script.render = render

export default script